//Reselect selector
//Takes a driver allocation object and retrieves the required driver allocation properties

import { createSelector } from 'reselect';
import {
  setDefaultSource,
  getCountries,
} from '../../../utils/helpers/costcenter';

import { getFilterCountries } from '../../../utils/globalSelectors';

// Create select function to pick off the pieces of state we care about for this calculation
const getVehicleRelocationSelector = state =>
  state.relocation.vehicleRelocation;

const getVehicleRelocationCostCenterSelector = state => state.common.costcenter;

const getVehicleRelocationCountrySelector = state => state.common.country;

//derieve/ extract the required props from the driver allocation object
const getVehicleRelocationProps = vehicleRelocation => {
  const {
    fetchingVehicles,
    vehicles,
    totalVehicles,
    currentPage,
    fetchingVehicleDetails,
    vehicleDetails,
    avaiableCostCenter,
  } = vehicleRelocation;

  return {
    fetchingVehicles,
    vehicles,
    totalVehicles,
    currentPage,
    fetchingVehicleDetails,
    vehicleDetails,
    avaiableCostCenter,
  };
};

const getDynamicFilterData = state => state.common.dynamicFilters;

const getRestrictionFilterSelector = dynamicFilters => {
  let restrictions = [];

  if (dynamicFilters && dynamicFilters.length > 0) {
    dynamicFilters.forEach(item => {
      if (item.value.length <= 0) return;

      restrictions.push({
        typeId: item.typeId,
        values: item.value.map(val => val.value),
      });
    });
  }

  return { restrictions };
};

const getVehicleRelocationCCAndCountryProps = (
  costcenter,
  country,
  countries
) => {
  return setDefaultSource(country, costcenter, countries);
};

export const getVehicleRelocation = createSelector(
  getVehicleRelocationSelector, //pick off a piece of state
  getVehicleRelocationProps // last argument is the function that has our select logic -- in our case its pretty simple logic of extracting props.
);

export const getVehicleRelocationCCAndCountry = createSelector(
  getVehicleRelocationCostCenterSelector,
  getVehicleRelocationCountrySelector,
  getFilterCountries,
  getVehicleRelocationCCAndCountryProps
);

export const getRestrictionFilter = createSelector(
  getDynamicFilterData,
  getRestrictionFilterSelector
);



// WEBPACK FOOTER //
// ./src/features/relocations/vehicle/selector.js